// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3sNSg","modal":"Modal_modal__3DuJO","slide-down":"Modal_slide-down__3FvCU"};